import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text, useTheme } from 'mintel-react-ui';

import { DangerousSpan, DangerousCite } from '/components/common';
import Context from '/components/Context';
import { QuoteContainerJson, Theme } from '/types';
import { BlockBackgroundContext } from '/utils/contexts';

import styles from './QuoteColumn.scss';

const QuoteColumn: VFC<
  Omit<QuoteContainerJson, 'type' | 'name' | 'hidden'> & { hide?: boolean }
> = ({ background, elements, hide = false }) => {
  const theme: Theme = useTheme();
  const { darkBg } = useContext(BlockBackgroundContext);

  return (
    <div
      className={classNames(styles.transition, {
        [styles[`${background}-${theme}`]]: background,
        [styles.hide]: hide,
      })}
    >
      <q
        className={classNames(styles['big-quote'], {
          [styles['dark-bg']]: darkBg,
        })}
      >
        {'quote' in elements && (
          <Text.Body darkBg={darkBg}>
            <p>
              <DangerousSpan>{elements.quote.content}</DangerousSpan>
            </p>
          </Text.Body>
        )}
        {typeof elements.context !== 'undefined' && (
          <DangerousCite className={styles.cite}>
            <Context content={elements.context.content} />
          </DangerousCite>
        )}
      </q>
    </div>
  );
};

export default QuoteColumn;
